module.exports = __webpack_public_path__ + "static/media/busan1st.3ca1ab52.png";